import logo from "../img/ems.png";
import React from "react";

const Header = () => {
    return(
        <div className="text-center">
            <img src={logo} className="img-fluid" style={{maxHeight: "80px", pointerEvents: "none", userSelect: "none"}}
                 alt="logo"/>
        </div>
    )
}

export default Header;